export default {"src":"/_next/static/media/accenture.6cc4bc0d.svg","height":42,"width":40,"blurWidth":0,"blurHeight":0};